import React, {useState} from "react";
import {Slide, toast, ToastContainer} from "react-toastify";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Col, Row, Spinner} from "react-bootstrap";
import RequiredLabel from "./RequiredLabel";

function FormModel({handleClose,
                       type,
                       sujet,
                       formEntreprise = true,
                       entrepriseName
} ){

    const [nom, setNom] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [phone, setPhone] = useState('');
    const [entreprise, setEntreprise] = useState('');

    const [nomError, setNomError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [messageError, setMessageError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [entrepriseError, setEntrepriseError] = useState('');

    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

        let isValid = true;
        setNomError('');
        setEntrepriseError('');
        setEmailError('');
        setMessageError('');
        setPhoneError('');

        if (!nom.trim()) {
            setNomError('Veuillez entrer votre nom.');
            isValid = false;
        }
        if (phone.trim()) {
            if (!phoneRegex.test(phone)) {
                setPhoneError('Veuillez entrer un numéro de téléphone valide (ex : 06 12 34 56 78).');
                isValid = false;
            }
        } else if (type !== 2 && !phone.trim()) {
            setPhoneError('Veuillez entrer un numéro de téléphone.');
            isValid = false;
        }

        if (!email.trim()) {
            setEmailError('Veuillez entrer une adresse e-mail.');
            isValid = false;
        } else if (!emailRegex.test(email)) {
            setEmailError('Veuillez entrer une adresse e-mail valide.');
            isValid = false;
        }
        if (formEntreprise && !entreprise.trim()) {
            setEntrepriseError('Veuillez entrer votre société.');
            return false;
        }
        if (!message.trim()) {
            setMessageError('Veuillez entrer un message.');
            isValid = false;
        }

        return isValid;
    };

    const fetchWithTimeout = (url, options, timeout = 10000) => {
        return Promise.race([
            fetch(url, options),
            new Promise((_, reject) => setTimeout(() => reject(new Error("Request timed out")), timeout))
        ]);
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        setIsSubmitting(true);
        const formData = {
            sujet: sujet || 'Demande de contact Webinaire',
            type,
            message,
            nom,
            entreprise: entreprise?.trim() || entrepriseName,
            phone,
            sender:
            email,
            webinaire: true,
        };

        try {
            const response = await fetchWithTimeout(process.env.REACT_APP_API_BASE_URL + '/contacts', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('Données envoyées avec succès');
                toast.success('Votre message a été envoyé avec succès !', {
                    onClose: () => {
                        if (typeof handleClose === 'function') {
                            handleClose();
                        }
                        setNom('');
                        setEmail('');
                        setEntreprise('');
                        setMessage('');
                        setPhone('');
                        setIsSubmitting(false);
                    },
                });
            } else {
                console.error('Une erreur est survenue lors de l\'envoi des données');
                toast.error('Une erreur est survenue lors de l\'envoi des données.');
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error('Une erreur est survenue lors de la requête :', error);
            toast.error('Une erreur est survenue lors de la requête.');
            setIsSubmitting(false);
        }
    };

    return(
            <>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                    transition={Slide}
                />
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label><RequiredLabel label="Nom" /></Form.Label>
                                <Form.Control
                                        type="text"
                                        name="nom"
                                        placeholder="Votre nom"
                                        required={true}
                                        value={nom}
                                        className="custom-placeholder"
                                        onChange={(e) => setNom(e.target.value)}
                                />
                                {nomError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{nomError}</div>}
                            </Form.Group>
                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput2">
                                <Form.Label><RequiredLabel label="E-mail" /></Form.Label>
                                <Form.Control
                                        type="email"
                                        name="sender"
                                        placeholder="Votre e-mail"
                                        value={email}
                                        required={true}
                                        className="custom-placeholder"
                                        onChange={(e) => setEmail(e.target.value)}
                                />
                                {emailError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{emailError}</div>}
                            </Form.Group>
                            <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput4">
                                <Form.Label>Téléphone</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="phone"
                                    value={phone}
                                    placeholder="Votre numéro de téléphone"
                                    className="custom-placeholder"
                                    onChange={(e) => setPhone(e.target.value)}
                                    required={type !== 2}
                                />
                                {phoneError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{phoneError}</div>}
                            </Form.Group>

                                <Form.Group
                                    className="form-group mb-3"
                                    controlId="exampleForm.ControlInput1"
                                    style={{ display: formEntreprise ? 'block' : 'none' }}
                                >
                                    <Form.Label>
                                        {formEntreprise ? (
                                            <RequiredLabel label="Entreprise / Organisation" />
                                        ) : (
                                            <>Entreprise / Organisation</>
                                        )}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="entreprise"
                                        placeholder="Votre société"
                                        required={formEntreprise ? true : false}
                                        value={entreprise}
                                        className="custom-placeholder"
                                        onChange={(e) => setEntreprise(e.target.value)}
                                    />
                                    {entrepriseError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{entrepriseError}</div>}
                                </Form.Group>

                        </Col>
                        <Col md={6}>
                            <Form.Group
                                className={formEntreprise ? "form-group mb-3" : "form-group textarea2 mb-3"}
                                controlId="exampleForm.ControlTextarea6"
                            >
                                <Form.Label><RequiredLabel label="Message" /></Form.Label>
                                <Form.Control
                                        as="textarea"
                                        placeholder="Votre message"
                                        rows={3}
                                        value={message}
                                        required={true}
                                        className="custom-placeholder"
                                        onChange={(e) => setMessage(e.target.value)}
                                />
                                {messageError && <div style={{ color: '#AB3331', fontStyle: 'italic', fontSize: 'small' }}>{messageError}</div>}
                            </Form.Group>
                        </Col>


                    </Row>

                </Form>


                <Button
                        className="theme-btn btn-style-one small mt-4"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        style={{display: "block", margin: "0 auto"}}
                >
                    {isSubmitting ? <Spinner animation="border" size="sm" /> : 'Envoyer ma demande'}
                </Button>
            </>
    )
}

export default FormModel;
